export enum AppRoutes {
    NOT_FOUND = 'not-found',
    READINGS = 'readings',
}
